import { useCheckInMemo } from "../../hooks/useCheckInMemo";
import { Dialog } from "../common/dialog";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { Button } from "../common/button";
import { useTranslation } from "react-i18next";
import { twclsx } from "../../utils/cssUtil";

export const CheckInMemoForm = forwardRef<
  HTMLDialogElement,
  { eventId: number; rewardId: number; checkInId: number }
>(({ eventId, rewardId, checkInId }, ref) => {
  const { postMemo, isPending } = useCheckInMemo({
    eventId,
    rewardId,
    checkInId,
  });
  const { t } = useTranslation();
  const [memo, setMemo] = useState<string>("");
  const formRef = useRef<HTMLDialogElement>(null);
  const [verify, setVerify] = useState(false);

  useImperativeHandle(ref, () => {
    return {
      showModal() {
        formRef.current?.showModal();
      },
    } as HTMLDialogElement;
  }, []);

  const closeHandle = () => {
    setMemo("");
    setVerify(false);
    formRef.current?.close();
  };

  return (
    <>
      <Dialog ref={formRef}>
        <div className={"flex justify-between align-middle"}>
          <p className={"my-auto"}>
            {t("eventdetail_cloudmemo_popup_subtitle")}
          </p>
          <button className={"btn-ghost btn-md"} onClick={closeHandle}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              className="size-4"
            >
              <path d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
            </svg>
          </button>
        </div>

        <form
          className={"w-full"}
          method={"dialog"}
          onSubmit={async (e) => {
            e.preventDefault();
            setVerify(true);
            if (memo) {
              await postMemo({ memo });
              closeHandle();
            }
          }}
          onReset={closeHandle}
        >
          <label className={"form-control"}>
            <textarea
              maxLength={500}
              className={twclsx(
                "textarea w-full textarea-bordered",
                verify && !memo && "textarea-error",
              )}
              onChange={(e) => {
                setVerify(false);
                const text = e.target.value;
                if (text.length <= 500) {
                  setMemo(text);
                }
              }}
              placeholder={t("eventdetail_cloudmemo_popup_placeholder")}
              value={memo}
            />
            {verify && !memo && (
              <div className={"label"}>
                <span className={"label-text-alt text-error"}>
                  {t("eventdetail_cloudmemo_popup_errormsg")}
                </span>
              </div>
            )}
          </label>
          <div className={"modal-action"}>
            <Button loading={isPending} className={"btn-ghost"} type={"reset"}>
              {t("common_dialog_cancel")}
            </Button>
            <Button loading={isPending} type={"submit"}>
              {t("common_dialog_save")}
            </Button>
          </div>
        </form>
      </Dialog>
    </>
  );
});
